import { ComboBoxModel } from "segov-sigepo-public-api";

export enum EMotivo {
  Sugestao = "Sugestão",
  Solicitacao = "Solicitação",
  Elogio = "Elogio",
  Reclamao = "Reclamação"
}

export const EMotivoDescricao: Record<EMotivo, string> = {
  [EMotivo.Sugestao]: 'Sugestão',
  [EMotivo.Solicitacao]: 'Solicitação',
  [EMotivo.Elogio]: 'Elogio',
  [EMotivo.Reclamao]: 'Reclamação'
};

export function toMotivoCombo(items: EMotivo[]): ComboBoxModel[] {
  return items.map(
    motivo => new ComboBoxModel(motivo.toString(), EMotivoDescricao[motivo])
  );
}

export function obterTodosMotivosCombo(): ComboBoxModel[] {
  return toMotivoCombo([
    EMotivo.Sugestao,
    EMotivo.Solicitacao,
    EMotivo.Elogio,
    EMotivo.Reclamao
  ]);
}
